import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlankPageLandscape: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="blank-page-landscape"><path d="M21.25 4.75H2.75V12.1786C2.75 14.6826 3.92497 17.0405 5.92143 18.5429C6.53139 19.0019 7.27327 19.25 8.03571 19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M2.75 5.69727C2.75 8.43231 3.83283 11.0553 5.76029 12.9893L6.86111 14.0938C5.83333 15.6407 5.83333 19.2501 8.40278 19.2501" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBlankPageLandscape;
